module.exports = __webpack_public_path__ + "static/assets/98760e9a26be1c3ab6cd6850eccd74dc.png";